/**
 * Sponsor subscription gating for the web app (NOS-170). Mirrors
 * supabase/functions/_shared/sponsorBilling.ts (Deno and web can't share a
 * module) — keep the two in sync.
 */

export const SPONSOR_PRICE_DOLLARS = 299
export const FOUNDING_PRICE_DOLLARS = 199

export type SponsorSubscriptionStatus = "none" | "active" | "grace" | "suspended"

export interface SponsorBillingFields {
  sponsor_subscription_status: string
  grace_expires_at: string | null
  sponsor_manual_active: boolean
  is_founding_sponsor: boolean
}

/** Lazy grace expiry — no cron; evaluated at read time. */
export function effectiveSponsorStatus(
  status: string,
  graceExpiresAt: string | null,
  now: Date = new Date()
): SponsorSubscriptionStatus {
  if (status === "grace") {
    if (graceExpiresAt && new Date(graceExpiresAt) > now) return "grace"
    return "suspended"
  }
  if (status === "active" || status === "suspended" || status === "none") {
    return status
  }
  return "none"
}

/** Console access: active + unexpired grace (read-only); manual flag wins. */
export function canAccessConsole(fields: SponsorBillingFields, now: Date = new Date()): boolean {
  if (fields.sponsor_manual_active) return true
  const effective = effectiveSponsorStatus(
    fields.sponsor_subscription_status,
    fields.grace_expires_at,
    now
  )
  return effective === "active" || effective === "grace"
}

/** Writes (new sponsorships, disbursements): active or manual only. */
export function canWriteAsSponsor(fields: SponsorBillingFields, now: Date = new Date()): boolean {
  if (fields.sponsor_manual_active) return true
  return (
    effectiveSponsorStatus(fields.sponsor_subscription_status, fields.grace_expires_at, now) ===
    "active"
  )
}
